import { useTheme } from '@mui/material';

import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    listItemRoot: {
      padding: 0,
    },
    listItemButton: {
      position: 'relative',
      cursor: 'pointer',
      textTransform: 'initial',
      padding: theme.spacing(0.5, 0),
      '&:hover .MuiAvatar-root': {
        msTransform: 'scale(1.2)',
        webkitTransform: 'scale(1.2)',
        transform: 'scale(1.2)',
        border: `2px solid ${legacyColors.blue}`,
      },
    },
    listItemAvatar: { display: 'flex', justifyContent: 'center' },
    primaryElement: { fontWeight: 'bold' },
    secondaryElement: {
      color: theme.palette.text.primary,
      lineHeight: 1.1,
    },
    statusNew: {
      backgroundColor: legacyColors.text.success,
      color: theme.palette.common.white,
      fontSize: '12px',
      padding: '2px 4px',
      border: `1px solid ${legacyColors.grey5}`,
      borderRadius: '3px',
      position: 'absolute',
      top: '4px',
      right: '4px',
    },
  };
};
